<div class="page-container">
  <div class="page-header">
    <div>
      <h1 class="gradient-text">Реальний трафік</h1>
      <p class="subtitle">Кількість авто у розрізі годин, днів та точок проїзду</p>
    </div>
  </div>

  <mat-tab-group>
    <mat-tab label="По годинах">
      <div class="tab-content">
        <mat-card>
          <mat-card-content>
            <h3>Трафік за сьогодні</h3>
            <div class="chart-container">
              <canvas baseChart
                [data]="hourlyChartData"
                [options]="hourlyChartOptions"
                type="bar">
              </canvas>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </mat-tab>

    <mat-tab label="По днях">
      <div class="tab-content">
        <mat-card>
          <mat-card-content>
            <h3>Трафік за тиждень</h3>
            <div class="chart-container">
              <canvas baseChart
                [data]="dailyChartData"
                [options]="hourlyChartOptions"
                type="line">
              </canvas>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </mat-tab>

    <mat-tab label="По точках проїзду">
      <div class="tab-content">
        <mat-card>
          <mat-card-content>
            <table mat-table [dataSource]="locationTraffic" class="traffic-table">
              <ng-container matColumnDef="location">
                <th mat-header-cell *matHeaderCellDef>Точка проїзду</th>
                <td mat-cell *matCellDef="let item">
                  <div class="location-info">
                    <mat-icon>place</mat-icon>
                    <span>{{item.location}}</span>
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="count">
                <th mat-header-cell *matHeaderCellDef>Кількість авто</th>
                <td mat-cell *matCellDef="let item">
                  <span class="count">{{item.count}}</span>
                </td>
              </ng-container>

              <ng-container matColumnDef="percentage">
                <th mat-header-cell *matHeaderCellDef>Частка</th>
                <td mat-cell *matCellDef="let item">
                  <div class="percentage-bar">
                    <div class="bar" [style.width.%]="getPercentage(item.count)"></div>
                    <span>{{getPercentage(item.count)}}%</span>
                  </div>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="locationColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: locationColumns;"></tr>
            </table>
          </mat-card-content>
        </mat-card>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
